import { render, staticRenderFns } from "./PickupOrderDetail.vue?vue&type=template&id=fe156754&"
import script from "./PickupOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PickupOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PickupOrderDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports